import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCalendarSync = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M5.602 1.172a1.031 1.031 0 1 1 2.063 0v.802h6.187v-.802a1.031 1.031 0 1 1 2.063 0v.802h2.52a2.75 2.75 0 0 1 2.75 2.75v8.15q.44.327.815.725v-.968a1 1 0 0 1 2 0v3.61a1 1 0 0 1-1 1h-3.61a1 1 0 1 1 0-2h1.388a4.24 4.24 0 0 0-7.058.643 1 1 0 1 1-1.765-.941 6.24 6.24 0 0 1 7.168-3.077v-.725H3.081v7.25c0 .38.308.687.688.687h4.656v2.063H3.77a2.75 2.75 0 0 1-2.75-2.75V4.724a2.75 2.75 0 0 1 2.75-2.75h1.833zm8.25 2.864v2.407a1.031 1.031 0 1 0 2.063 0V4.036h2.52c.38 0 .688.308.688.688v4.583H3.081V4.724c0-.38.308-.688.688-.688h1.833v2.407a1.031 1.031 0 0 0 2.063 0V4.036z"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      d="M15.345 21.557a4.24 4.24 0 0 0 5.839-1.655 1 1 0 1 1 1.758.954 6.24 6.24 0 0 1-10.368.91v.993a1 1 0 0 1-2 0V19.15a1 1 0 0 1 1-1h3.609a1 1 0 1 1 0 2h-1.308c.368.58.872 1.064 1.47 1.407"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgCalendarSync);
export default Memo;
